import { Component, OnInit, ViewChild, ElementRef, Injectable, EventEmitter, Output, ChangeDetectorRef} from '@angular/core';
import { DatePipe } from '@angular/common';
import { CookieService, BatchUploadService } from '../_services/index';
import { ExcelRow } from './excel-row.interface';
import { } from 'googlemaps';
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import * as XLSX from 'xlsx'
import { updateRestTypeNode } from 'typescript';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


declare var $: any;
declare var google: any;
declare var REP: any;

@Component({
  selector: 'app-batchupload',
  templateUrl: './batchupload.component.html',
  styleUrls: ['./batchupload.component.css']
})

export class BatchuploadComponent implements OnInit {

  @ViewChild('excelFile') excelFile: ElementRef;
  @ViewChild('editingOrderForm') editingOrderForm: NgForm;

  batchOrderForm: FormGroup

  excelJson
  batchOrderData = []
  excelCols = []

  selectedSheet;
  sheets = [];
  rawExcelJson;
  
  reportTypeList
  batchList
  countries
  excelArray
  editingOrder
  batchID
  
  errorMessage = ''
  successMessage = ''
  updateFailedMessage = ''
  wrongHeader = []
  exportErrorMessage: string = '';
  exportSuccessMessage: string = '';


  batchSaveFailed = false
  wrongType = false
  updateFailed = false
  noFile = true
  wrongColNamesSpace = false
  colHeaderDoesntExist = false
  invalidRecord = false
  noFileFound = true

  bulkStatus

  deletedRecordID

  loadingSave
  loadingPlaceOrder
  loadingConfirm
  loadingDelete
  loadingUpload
  loadingReportType
  loadingBatchList
  loadingBatchData
  loadingDeleteAll
  loadingPackage
  savedGeoLayer: any;
 changeDetectorRef: any;
 packages=[];
  // Define a loading flag for the export process
  loadingExport = false;
  allowClientBatch='N';
  constructor(private cookieService: CookieService, private batchUploadService: BatchUploadService, private formBuilder: FormBuilder, private cdf: ChangeDetectorRef) { 
    this.allowClientBatch=this.cookieService.getCookie("allowClientBatch"),
    this.batchOrderForm = this.buildOrderForm()

  }

  ngOnInit(): void {
    this.noFile = true
    this.errorMessage = ''
    this.successMessage = ''
   // if(this.allowClientBatch=='Y'){
      this.getPackages();
   // }else{
    //  this.getReportTypes();
    //}    
    this.getBatchList();
    this.resetSheet();

    this.countries = [
      { "Name": "CA", "Key": "CA"},
      { "Name": "US", "Key": "US"}
    ]

    this.excelCols = [
      {"TableHeader": "Project Name", "DataHeader": "SITE_NAME"},
      {"TableHeader": "Address", "DataHeader": "ADDRESS"},
      {"TableHeader": "City", "DataHeader": "CITY"},
      {"TableHeader": "Prov/State", "DataHeader": "PROVSTATE"},
      {"TableHeader": "Postal", "DataHeader": "POSTAL"},
      {"TableHeader": "P.O./Project Number", "DataHeader": "PO_NUM"},
      {"TableHeader": "Country", "DataHeader": "COUNTRY"},
      {"TableHeader": "Latitude", "DataHeader": "LATITUDE"},
      {"TableHeader": "Longitude", "DataHeader": "LONGITUDE"},
      {"TableHeader": "Order Number", "DataHeader": "ORDER_NUMBER"},
      {"TableHeader": "Site Status", "DataHeader": "SITE_STATUS"},
      {"TableHeader": "", "DataHeader": ""}
    ]
  }


  buildOrderForm(): FormGroup {
    if(this.allowClientBatch=='Y'){
      return this.formBuilder.group({
        batchID: new FormControl(undefined),
        batchReportType: new FormControl(undefined, Validators.required),
        batchProjectName: new FormControl(undefined, Validators.required),
        batchCountry: new FormControl(undefined, Validators.required),
        batchContactName: new FormControl(undefined),
        batchAltEmail: new FormControl(undefined)
      })
    }else{
      return this.formBuilder.group({
        batchID: new FormControl(undefined),
        batchCustomerID: new FormControl(undefined, Validators.required),
        batchReportType: new FormControl(undefined, Validators.required),
        batchProjectName: new FormControl(undefined, Validators.required),
        batchCountry: new FormControl(undefined, Validators.required),
        batchDueDate: new FormControl(undefined),
        batchChargeReport: new FormControl(undefined, Validators.required),
        batchContactName: new FormControl(undefined),
        batchAltEmail: new FormControl(undefined)
      })
    }
    
  }
  
  /*getReportTypes() {
      let inputJson = {
          "PROCEDURE": 'getbulkreporttype',
          "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
          "SESSION_ID": this.cookieService.getCookie("sessionKey")
      }

      this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
        this.loadingReportType = false        
        let reportDetails = JSON.parse(response._body)
        this.reportTypeList = reportDetails.REPORT_LIST
      });
      this.loadingReportType = true
  }*/

  currentBulkCustomerId = ""
  getPackages() {
    let inputJson;
    let formControls = this.batchOrderForm.controls;
    if ("batchCustomerID" in formControls) {
      //check if user can batch upload for client
      if (this.currentBulkCustomerId == formControls['batchCustomerID'].value) {
        //prevent reload after user clicks off Batch Customer ID without changing the value
        return
      }
      this.currentBulkCustomerId = formControls['batchCustomerID'].value
      
    } else {
    //User is client, cannot place order for other clients
      this.currentBulkCustomerId = this.cookieService.getCookie('customerID')
    }

    inputJson = {
      "PROCEDURE": 'getcustomerpackages',
      "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
      "SESSION_ID": this.cookieService.getCookie("sessionKey"),
      "BULK_CUSTOMER_ID": this.currentBulkCustomerId
  }



    this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
      this.loadingPackage = false        
      let reportDetails = JSON.parse(response._body);console.log(reportDetails)
      this.packages = reportDetails.PACKAGES;
    });
    this.loadingPackage = true
}
  getBatchList() {
      let inputJson = {
          "PROCEDURE": 'getuserbatchlist',
          "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
          "SESSION_ID": this.cookieService.getCookie("sessionKey")
      }

      this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
        this.loadingBatchList = false
          let data = JSON.parse(response._body)
          this.batchList = data.BATCH_LIST
      });
      this.loadingBatchList = true
  }

  loadFile() {
    this.noFileFound = true
    this.loadingUpload = true
    this.errorMessage = ''
    this.successMessage = ''
    // if (this.batchID === undefined) {
    //   console.log("Undefined")
    //   this.batchOrderData = []
    // }
    this.wrongType = false
    this.noFile = true
    this.wrongColNamesSpace = false
    this.colHeaderDoesntExist = false

    this.wrongHeader = []

    let that = this

    const file = this.excelFile.nativeElement.files[0]
    let excelFileName = file.name

    let extension = excelFileName.slice(excelFileName.length - 4)
    if (this.excelFile.nativeElement.value === '') {
      this.noFile = true
      return
    } else {
      this.noFile = false
    }

    if (extension !== 'xlsx') {
        this.wrongType = true
        return
    } else {
        this.wrongType = false
    }

    let reader = new FileReader()
    reader.onloadend = function (e) {
      var data = e.target.result
      let workBook = XLSX.read(data, {type: 'binary'})
      let jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name]
          initial[name] = XLSX.utils.sheet_to_json(sheet, {header: 0, raw: false})
          return initial
      }, {});
      
      for (var key in jsonData) {
          if (Object.prototype.hasOwnProperty.call(jsonData, key)) {
            that.sheets[0]=key
          }
      }
      that.selectedSheet = that.sheets[0]
      that.rawExcelJson = jsonData
      that.checkColNames(that.rawExcelJson[that.selectedSheet])

      if (that.wrongColNamesSpace || that.colHeaderDoesntExist) {
        that.loadingUpload = false;
        return
      } else {
        that.selectSheet()
        that.reinitializeDataTable()        
      }

      that.excelFile.nativeElement.value = ''

      if (that.wrongColNamesSpace === false) {
        document.getElementById('loadExcel').click()
      }
      that.loadingUpload = false      
    }
    reader.readAsBinaryString(file)
  }

  resetSheet() {
      this.excelJson = null
      this.batchOrderData = []

      this.wrongType = false

      this.selectedSheet = null
      this.sheets = []
      this.rawExcelJson = []
  }

  saveBulkOrder() {
      this.errorMessage = ''
      this.successMessage = ''
      this.batchSaveFailed = false
      let listingInput = []
      this.batchOrderData.forEach((excelRow) => {
        if (excelRow.SITE_STATUS === null) {
          let entry = {
              "SITE_NAME": excelRow.SITE_NAME,
              "PO_NUM": excelRow.PO_NUM,
              "ADDRESS": excelRow.ADDRESS,
              "CITY": excelRow.CITY,
              "PROVSTATE": excelRow.PROVSTATE,
              "POSTAL": excelRow.POSTAL,
              "COUNTRY": excelRow.COUNTRY,
              "LATITUDE": excelRow.LATITUDE,
              "LONGITUDE": excelRow.LONGITUDE,
              "REC_ID": excelRow.REC_ID
          }
          listingInput.push(entry)
        }
      })
      
      let formControls = this.batchOrderForm.controls;
      let inputJson = {
          "PROCEDURE": 'savebulkorder',
          "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
          "SESSION_ID": this.cookieService.getCookie("sessionKey"),
          //"BULK_CUSTOMER_ID": formControls['batchCustomerID'].value,
          "BATCH_ID": formControls['batchID'].value,
          "PROJECT": formControls['batchProjectName'].value,
          'PACKAGE_OID': formControls['batchReportType'].value,
          "REPORT_TYPE": '',
          //"DATE_DUE": new DatePipe('en-EN').transform(formControls['batchDueDate'].value, 'dd-MMM-yy'),
          //"CHARGE_REPORT": formControls['batchChargeReport'].value,
          "CONTACT_NAME": formControls['batchContactName'].value,
          "ALT_EMAIL": formControls['batchAltEmail'].value,
          "COUNTRY": formControls['batchCountry'].value,
          "SITES": listingInput
      }
      if(this.allowClientBatch=='Y'){
        //inputJson['PACKAGE_OID']=formControls['batchReportType'].value;
        inputJson['BULK_CUSTOMER_ID']=null;
        //inputJson['REPORT_TYPE']='';
        inputJson['DATE_DUE']='';
        inputJson['CHARGE_REPORT']=0;
      }else{
        inputJson['BULK_CUSTOMER_ID']=formControls['batchCustomerID'].value;
       // inputJson['REPORT_TYPE']=formControls['batchReportType'].value;
        inputJson['DATE_DUE']=new DatePipe('en-EN').transform(formControls['batchDueDate'].value, 'dd-MMM-yy');
        inputJson['CHARGE_REPORT']=formControls['batchChargeReport'].value;
        //inputJson['PACKAGE_OID']=0;
      }
      this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {

          this.loadingSave = false
          let data = JSON.parse(response._body)
          if(data.STATUS === 'N') {
              this.batchSaveFailed = true
              this.errorMessage = data.ERRORMESSAGE
              this.disableBatch('')
              return
          } else {
              this.batchSaveFailed = false
              this.successMessage = "Saved Successfully";
              if(data.SITES.length > 0) {
                this.batchID = data.SITES[0].BATCH_ID;
              }
              this.getBatchOrderData(data, true)    
              this.reinitializeDataTable() 
              this.getBatchList()
              this.disableBatch('Open')
          }

          
      });
      this.loadingSave = true
      this.disableBatch('Closed')
  }
  selectSheet() {
    this.excelJson = this.rawExcelJson[this.selectedSheet];
    this.loadData()
  }

  loadData() {    

    //let appendData = this.batchOrderData.length === 0 ? false : true
    //let table = $('#data-table').DataTable();
    this.excelJson.forEach((row) => {
        let excelRow = new ExcelRow();
        Object.keys(row).forEach((key) => {
          if (key.toUpperCase() === 'SITE_NAME') {
            excelRow.SITE_NAME = row[key]
          } else if (key.toUpperCase() === 'POBOX'){
            excelRow.PO_NUM = row[key]
          } else if (key.toUpperCase() === 'ADDRESS1') {
            excelRow.ADDRESS = row[key]
          } else if (key.toUpperCase() === 'CITY') {
            excelRow.CITY = row[key]
          } else if (key.toUpperCase() === 'PROVSTATE') {
            excelRow.PROVSTATE = row[key]
          } else if (key.toUpperCase() === 'POSTAL_CODE') {
            excelRow.POSTAL = row[key]
          } else if (key.toUpperCase() === 'COUNTRY') {
            excelRow.COUNTRY = row[key]
          } else if (key.toUpperCase() === 'LATITUDE') {
            excelRow.LATITUDE = row[key]
          } else if (key.toUpperCase() === 'LONGITUDE') {
            excelRow.LONGITUDE = row[key]
          }
        })
        this.batchOrderData.push(excelRow);  
    })
    
    // let table = $('#data-table').DataTable();
    // table.columns().draw()           
  }

  
  getBatchOrderData(responseData, removeData) {
    this.errorMessage = ''
    // this.successMessage = ''
    if (removeData) {

      this.batchOrderData = []
    }

    // $('#tbody tr').remove()
    // let table = $('#data-table').DataTable()    

    if (responseData.SITES !== undefined) {
      for(let site of responseData.SITES){
        let entry = {
            "SITE_NAME": site.SITE_NAME,
            "ADDRESS": site.ADDRESS,
            "CITY": site.CITY,
            "PROVSTATE": site.PROVSTATE,
            "POSTAL": site.POSTAL,
            "PO_NUM": site.PO_NUM,
            "COUNTRY": responseData.COUNTRY,
            "LATITUDE": site.LATITUDE,
            "LONGITUDE": site.LONGITUDE,
            "ORDER_NUMBER": site.ORDER_NUM === undefined || site.ORDER_NUM === null ? '' : site.ORDER_NUM,
            "SITE_STATUS": site.REC_STATUS,
            "REC_ID": site.REC_ID,
            "BATCH_ID": site.BATCH_ID,
            "COLOUR": site.GOOD_RECORD === 'Y' ? 'green' : 'red',
        }
        this.batchOrderData.push(entry)
        //table.row.add(this.convertToArray(entry)).invaliate().draw()
      }      
    }
  }

  editOrder(recID) {
    this.errorMessage = ''
    this.successMessage = ''
    this.updateFailedMessage = ''
      this.batchOrderData.forEach((order) => {
        if (order.REC_ID === recID) {
          this.editingOrderForm.setValue( {
            "editingSiteName": order.SITE_NAME,
            "editingAddress": order.ADDRESS,
            "editingCity": order.CITY,
            "editingState": order.PROVSTATE,
            "editingPC": order.POSTAL,
            "editingCountry": order.COUNTRY,
            "editingLatitude": order.LATITUDE,
            "editingLongitude": order.LONGITUDE
          })
          this.editingOrder = order
          return
        }
      })
    this.checkEditData()

    let orderMapCenter;
    let Zoom = 18;
    let e1 = document.getElementById("searchOrderMap");
    let that = this;

    let mapOp = {
      center: orderMapCenter,
      zoom: Zoom,
      controlSize: 24,
      scaleControl: true,
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [{
        "featureType": "poi", "stylers": [{ "visibility": "off" },
        {
          'featureType': 'transit',
          'elementType': 'labels.icon',
          'stylers': [{ visibility: 'off' }]
        }]
      }],
    };        

    let map = new google.maps.Map(e1, mapOp);
    
    REP.Layer.Google.Initialize(map);

    $('#orderMapModal').on('shown.bs.modal', function () {
      google.maps.event.trigger(map, "resize");
      map.setCenter(orderMapCenter);
    });
    
    let icon = {
      url: "assets/images/Site_Marker.png",
      scaledSize: new google.maps.Size(60, 40), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(30, 40)
    };

    const myLatLng = { lat: this.editingOrder.LATITUDE, lng: this.editingOrder.LONGITUDE };
    let formValueAddress = this.editingOrderForm.value
    let geocoder = new google.maps.Geocoder();
    let oriAddress = formValueAddress.editingAddress + ", " + formValueAddress.editingCity + ", " + formValueAddress.editingState + ", " + formValueAddress.editingCountry;
    geocoder.geocode({ 'address': oriAddress }, function (results) {
      if (results.length == 0) {
          return;
      }
      for (let i = 0; i < results.length; i++) {
          if (results[i].geometry.location_type == "ROOFTOP") {
              results[0] = results[i];
              map.setCenter(results[0].geometry.location);
              break
          }
      }
      clearPoly();
      that.savedGeoLayer = new google.maps.Marker({
          map: map,
          icon: icon,
          title: results[0].name,
          anchorPoint: new google.maps.Point(0, -25),
          position: myLatLng
      });            
      
      map.setCenter(myLatLng);
      this.checkEditData()
    });

    let box = document.getElementById("bigMapBox");
    box.className = "col-md-12";
    e1.style.height = "400px";
    e1.style.width = "100%";
    google.maps.event.trigger(map, 'resize');
    map.setCenter(myLatLng);
    map.setZoom(Zoom);

    google.maps.event.addListener(map, 'click', function(event) {
      geocoder.geocode({
        'latLng': event.latLng
      }, function(results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
              if (results.length == 0) {
                  return;
              }
              for (let i = 0; i < results.length; i++) {
                  if (results[i].geometry.location_type == "ROOFTOP") {
                      results[0] = results[i];
                      break
                  }
              }                    
              clearPoly();
              results[0].geometry.location.lat = event.latLng.lat;
              results[0].geometry.location.lng = event.latLng.lng;
              processGeocode(results)
              that.savedGeoLayer = new google.maps.Marker({
                  map: map,
                  icon: icon,
                  title: results[0].name,
                  anchorPoint: new google.maps.Point(0, -25),
                  position: event.latLng
              });
            }
            
          that.editingOrder.LATITUDE = event.latLng.lat;
          that.editingOrder.LONGITUDE = event.latLng.lng;
          that.checkEditData()
      });
    });

    document.getElementById('searchButton').addEventListener('click', function(e){
      let oriAddress = $('#editingAddress').val() + ", " + $('#editingCity').val() + ", " + $('#editingState').val() + ", " + $('#editingCountry').val();
      
      geocoder.geocode({ 'address': oriAddress }, function (results) {
          if (results.length == 0) {
              return;
          }
          for (let i = 0; i < results.length; i++) {
              if (results[i].geometry.location_type == "ROOFTOP") {
                  results[0] = results[i];
                  break
              }
          }
          clearPoly();
          processGeocode(results);
          that.savedGeoLayer = new google.maps.Marker({
              map: map,
              icon: icon,
              title: results[0].name,
              anchorPoint: new google.maps.Point(0, -25),
              position: results[0].geometry.location
          });
          map.setCenter(results[0].geometry.location);
          that.checkEditData()              
      });
    })

    function clearPoly() {
        if (that.savedGeoLayer) {
            that.savedGeoLayer.setMap(null);
        }
    }

    function processGeocode(results) {
        let lat, lng: number;
        lat = results[0].geometry.location.lat();
        lng = results[0].geometry.location.lng();
        for (let i = 0; i < results.length; i++) {
            if (results[i].geometry.location_type == "ROOFTOP") {
                results[0] = results[i];
                break
            }
        }
        let streetNo = "", city = "", provState = "", country = "", postalZip = "", street = "";
        for (let i = 0; i < results[0].address_components.length; i++) {
            if (results[0].address_components[i].types.indexOf("street_number") != -1) {
                streetNo = results[0].address_components[i] && results[0].address_components[i].long_name;
            }
            if (results[0].address_components[i].types.indexOf("administrative_area_level_1") != -1) {
                provState = results[0].address_components[i] && results[0].address_components[i].short_name;
            }
            if (results[0].address_components[i].types.indexOf("country") != -1) {
                country = results[0].address_components[i] && results[0].address_components[i].long_name;
                if ((country != "United States") && (country != "Canada")) {
                    alert("Only addresses within United States and Canada are accepted!");
                    return;
                }
            }
            if (((results[0].address_components[i].types).indexOf("locality") != -1)) {
                city = results[0].address_components[i] && results[0].address_components[i].long_name;
            }
            if (results[0].address_components[i].types.indexOf("postal_code") != -1) {
                postalZip = results[0].address_components[i] && results[0].address_components[i].long_name;
            }
            if ((results[0].address_components[i].types.indexOf("street_address") != -1) || (results[0].address_components[i].types.indexOf("route") != -1)) {
                street = results[0].address_components[i] && results[0].address_components[i].long_name;
            }
        }
        let address = results[0].formatted_address;
        let addressArray = address.split(',');
        let Address1 = addressArray[0];
        if (street == "") {
            city = addressArray[0].trim();
        } else {
            let streetArray = street.split(' ');
            let streetString = streetArray[0];
            for (let i = 0; i < addressArray.length; i++) {
                let streetName = addressArray[i].trim();
                if (streetName.indexOf(streetString) != -1) {
                    city = addressArray[i + 1].trim();
                    break
                } else {
                    city = addressArray[1].trim();
                }
            }
        }

        lat = Math.round((lat + Number.EPSILON) * 100000000) / 100000000
        lng = Math.round((lng + Number.EPSILON) * 100000000) / 100000000
        $('#editingAddress').val(streetNo + " " + street)
        $('#editingCity').val(city)
        $('#editingState').val(provState)
        $('#editingPC').val(postalZip)
        $('#editingCountry').val(country)
        $('#editingLatitude').val(lat)
        $('#editingLongitude').val(lng)

    }
  }

  checkEditData() {
    if ($('#editingAddress').val() === '' || $('#editingCity').val() === '' ||  $('#editingState').val() === '' || $('#editingPC').val() === '' 
        || $('#editingCountry').val() === '' || $('#editingLatitude').val() === '' || $('#editingLongitude').val() === '') {
          this.invalidRecord = true
    } else {
      this.invalidRecord = false
    }
    // console.log("invalidRecord: " + this.invalidRecord)
  }

  confirmUpdate() {
    let that = this
    this.updateFailedMessage = ''
    this.successMessage = ''
    let formValue = this.editingOrderForm.value
    let inputJson = {
        "PROCEDURE": "updatebulkrecord",
        "BATCH_ID": this.editingOrder.BATCH_ID,
        "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
        "SESSION_ID": this.cookieService.getCookie("sessionKey"),
        "REC_ID": this.editingOrder.REC_ID,
        "LATITUDE": $('#editingLatitude').val(),
        "LONGITUDE": $('#editingLongitude').val(),
        "ADDRESS": formValue.editingAddress,
        "CITY": formValue.editingCity,
        "PROVSTATE": formValue.editingState,
        "POSTAL": formValue.editingPC,
        "SITE_NAME": $('#editingSiteName').val()
    }
    this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
      this.loadingConfirm = false
        let data = JSON.parse(response._body)
        if (data.STATUS === 'N') {
          this.updateFailed = true
          this.updateFailedMessage = data.ERRORMESSAGE
          return
        } else {
          this.batchOrderData.forEach((order, index) => {
            if (order.REC_ID === this.editingOrder.REC_ID) {
              order.SITE_STATUS = 'Geocoded'
              order.COLOUR = 'green'

              order.ADDRESS = data.ADDRESS
              order.CITY = data.CITY
              order.PROVSTATE = data.PROVSTATE
              order.POSTAL = data.POSTAL
              order.LATITUDE = data.LATITUDE
              order.LONGITUDE = data.LONGITUDE
            }
          });
          this.updateFailed = false
          this.updateFailedMessage = ''
          this.successMessage = 'Order edited successfully'
          this.getBatchInfo(this.editingOrder.BATCH_ID)
        
          this.reinitializeDataTable()
          document.getElementById('orderMapClose').click()
        }
    });
    this.loadingConfirm = true
  }

  getBatchInfo(batchId){
    let inputJson = {
      "PROCEDURE": "getbulkinfo",
      "BATCH_ID": batchId,
      "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
      "SESSION_ID": this.cookieService.getCookie("sessionKey")
    }
    this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
      let data = JSON.parse(response._body)
      this.getBatchOrderData(data, true)
    });
  }

  retrieveBatchData() {
    this.errorMessage = ''
    this.successMessage = ''
    this.batchOrderData = []
    let formControls = this.batchOrderForm.controls
    this.batchID = formControls['batchID'].value
    let inputJson = {
      "PROCEDURE": "getbulkinfo",
      "BATCH_ID": formControls['batchID'].value,
      "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
      "SESSION_ID": this.cookieService.getCookie("sessionKey")
    }
    this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
      this.loadingBatchData = false
      let data = JSON.parse(response._body); console.log(data)
      this.bulkStatus = data.BULK_STATUS
      this.getBatchOrderData(data, true)
      $(function () {
        $('#data-table').DataTable({
            paging: false,
            //data: this.batchOrderData
        });
        let table = $('#data-table').DataTable()
        table.order([0, 'desc'])
      });
      if(this.allowClientBatch=='N'){
        formControls['batchCustomerID'].setValue(data.BULK_CUSTOMER_ID);
        formControls['batchDueDate'].setValue(data.DATE_DUE);
        formControls['batchChargeReport'].setValue(data.CHARGE_REPORT);
      }
      formControls['batchReportType'].setValue(data.PACKAGE_OID);
      formControls['batchProjectName'].setValue(data.PROJECT)
      formControls['batchCountry'].setValue(data.COUNTRY)      
      formControls['batchContactName'].setValue(data.CONTACT_NAME)
      formControls['batchAltEmail'].setValue(data.ALTERNATE_EMAIL)
      this.getPackages()
      this.disableBatch(this.bulkStatus)
    });
    this.loadingBatchData = true
  }

  placeOrder() {
    this.errorMessage = ''
    this.successMessage = ''
    //let that = this
    if(this.batchOrderForm.controls['batchID'].value){
      this.batchID=this.batchOrderForm.controls['batchID'].value;
    }
    let inputJson = {
      "PROCEDURE": "placebulkorder",
      "BATCH_ID": this.batchID, 
      "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
      "SESSION_ID": this.cookieService.getCookie("sessionKey")
    }
    this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
      this.loadingPlaceOrder = false
      if(response.STATUS === 'N') {
        this.errorMessage = response.ERRORMESSAGE
        this.disableBatch('')
      } else {
        let data = JSON.parse(response._body)
        this.bulkStatus = data.BULK_STATUS
        this.getBatchOrderData(data, true)
        this.reinitializeDataTable()
        
        this.successMessage = 'Order placed successfully'
        this.disableBatch(this.bulkStatus)
        this.getBatchList()
        this.disableBatch('Closed')
      }
    });
    this.loadingPlaceOrder = true
    this.disableBatch('Closed')    
  }

  checkColNames(jsonData) {
    this.wrongHeader = []
    let colNames = Object.keys(jsonData[0]).forEach((colName) => {
      if (colName.length !== colName.trim().length){
        this.wrongColNamesSpace = true
        return
      } else {
        this.wrongColNamesSpace = false
      }

      let headerFound = false

      for (let col of this.excelCols) {
        if (col.DataHeader === colName.toUpperCase() || colName.toUpperCase() === 'ADDRESS1' || colName.toUpperCase() === 'POSTAL_CODE' || colName.toUpperCase() === 'POBOX') {
          headerFound = true
          break
        }
      }

      if (!headerFound) {
        this.colHeaderDoesntExist = true
        this.wrongHeader.push(colName)
      }

    })
  }

  setRecID(recID) {
    this.deletedRecordID = recID
  }

  deleteOrder() {
    this.successMessage = ''
    this.errorMessage = ''
    this.batchOrderData.forEach((order, index) => {
      if (order.REC_ID === this.deletedRecordID) {
        let inputJson = {
          "PROCEDURE": "deletebulkrecord",
          "BATCH_ID": order.BATCH_ID,
          "CUSTOMER_ID": this.cookieService.getCookie("customerID"),
          "SESSION_ID": this.cookieService.getCookie("sessionKey"),
          "REC_ID": this.deletedRecordID
        }
        this.batchUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((response: any) => {
          this.loadingDelete = false
          let data = JSON.parse(response._body)
          if (data.STATUS === 'Y') {
            this.batchOrderData.splice(index, 1)            
            this.getBatchInfo(this.batchID)
            this.reinitializeDataTable()
            this.successMessage = 'Record deleted successfully'
          } else {
            this.errorMessage = data.ERRORMESSAGE
          }
          document.getElementById('deleteRecord').click()
          this.deletedRecordID = ''
        })
        this.loadingDelete = true
      }
    })
  }

  cancelDelete() {
    document.getElementById('deleteRecord').click()
  }

  disableBatch(bulkStatus) {
    if (bulkStatus == 'Closed') {
     this.batchOrderForm.controls['batchProjectName'].disable();
      this.batchOrderForm.controls['batchCountry'].disable();
      this.batchOrderForm.controls['batchReportType'].disable();
      this.batchOrderForm.controls['batchContactName'].disable();
      this.batchOrderForm.controls['batchAltEmail'].disable();
      if(this.allowClientBatch=='N'){
        this.batchOrderForm.controls['batchCustomerID'].disable();
        this.batchOrderForm.controls['batchDueDate'].disable();
        this.batchOrderForm.controls['batchChargeReport'].disable();
      }
    } else if (bulkStatus === 'Open') {
      this.batchOrderForm.controls['batchReportType'].disable();
      this.batchOrderForm.controls['batchProjectName'].disable();
      this.batchOrderForm.controls['batchCountry'].disable();
      this.batchOrderForm.controls['batchContactName'].enable();
      this.batchOrderForm.controls['batchAltEmail'].enable();
      if(this.allowClientBatch=='N'){
        this.batchOrderForm.controls['batchCustomerID'].disable();
        this.batchOrderForm.controls['batchDueDate'].enable();
        this.batchOrderForm.controls['batchChargeReport'].enable();
      }
    } else {
      this.batchOrderForm.controls['batchReportType'].enable();
      this.batchOrderForm.controls['batchProjectName'].enable();
      this.batchOrderForm.controls['batchCountry'].enable();
      this.batchOrderForm.controls['batchContactName'].enable();
      this.batchOrderForm.controls['batchAltEmail'].enable();
      if(this.allowClientBatch=='N'){
        this.batchOrderForm.controls['batchCustomerID'].enable();
        this.batchOrderForm.controls['batchDueDate'].enable();
        this.batchOrderForm.controls['batchChargeReport'].enable();
      }
    }
  }

  fileFound() {
     if (this.excelFile.nativeElement.value === '') {
      this.noFileFound = true
     } else {
      this.noFileFound = false
     }
  }

  reinitializeDataTable(){
    let that = this
    $(function () {

      let table = $('#data-table').DataTable();

      if (table != null){
        table.clear()
        table.destroy();
      }

      $('#data-table tbody').empty()

      $('#data-table').DataTable({
        data: that.batchOrderData,
        columns: [
          { data: 'SITE_NAME' },
          { data: 'ADDRESS' },
          { data: 'CITY' },
          { data: 'PROVSTATE' },
          { data: 'POSTAL' },
          { data: 'PO_NUM' },
          { data: 'COUNTRY' },
          { data: 'LATITUDE' },
          { data: 'LONGITUDE' },
          { data: 'ORDER_NUMBER' },
          { data: 'SITE_STATUS', 
              render: function (data, type, row, meta) {
                if (type === "display") {  
                  if (row.SITE_STATUS !== null) { 
                    data = '<span style="color:' + row.COLOUR + ';">' + row.SITE_STATUS + '</span>'
                  }
                }
                return data;
              }
          },
          {
            data: 'REC_ID',
            render: function (data, type, row, meta) {
              // console.log("SITE_STATUS:" + row.SITE_STATUS)
                if (type === 'display') {       
                  if ( data != null && row.REC_ID != null && row.SITE_STATUS !== null && row.SITE_STATUS !== 'Success') {                     
                    data = '<span>'             
                    data = data + '<a href="#' + row.REC_ID + '"  class="editOrder" data-toggle="modal" data-target="#orderMapModal"><img style="width:24px; Height:24px" src="assets/images/Edit.png" ></a>'
                    data = data + '<a href="#' + row.REC_ID + '" class="deleteOrder" id="deleteOrder" data-toggle="modal" data-target="#deleteRecordModal"><img style="width:24px; Height:24px" src="assets/images/Trash.png"></a>';

                    if (that.loadingDelete && that.deletedRecordID === row.REC_ID){
                      data = data + '<i id="spinner" class="fa fa-spinner fa-spin" style="font-size:12px;"></i>'
                    }                      
                    
                    data = data + '</span>'
                  }
                  else{
                    data = ''
                  }
                }
                return data;
            }
          }
        ],
        paging: false,
        destroy: true
      });

      table = $('#data-table').DataTable()
      table.clear()
      table.rows.add(that.batchOrderData).invalidate().draw()
      table.columns.adjust().draw()
      table.order([0, 'desc'])
    

      const editButtons = Array.from(document.getElementsByClassName("editOrder"));
      editButtons.forEach(btn => {
        if (btn !== null){
          btn.addEventListener('click', function handleClick(event) {
            let hrefAttr = btn.getAttribute("href");
            let recID = +hrefAttr.substring(1)
            that.editOrder(recID)
          });
        }
      });

      const deleteButtons = Array.from(document.getElementsByClassName("deleteOrder"));      
      deleteButtons.forEach(btn => {
        if (btn !== null){
          btn.addEventListener('click', function handleClick(event) {
            let hrefAttr = btn.getAttribute("href");
            let recID = +hrefAttr.substring(1)
            that.deletedRecordID = recID;
          });
        }
      });

    });
    
  }

  deleteNonGeocodedRecords() {
    if (this.batchID) {
      const requestJson = {
        PROCEDURE: 'deletenongeocoded',
        BATCH_ID: this.batchID,
        CUSTOMER_ID: this.cookieService.getCookie('customerID'),
        SESSION_ID: this.cookieService.getCookie('sessionKey'),
      };
  
      this.batchUploadService.serviceCall(JSON.stringify(requestJson)).subscribe(
        (response: any) => {
          const data = JSON.parse(response._body);
  
          if (data.STATUS === 'Y') {
            // Update the batchOrderData with the updated list
            this.getBatchInfo(this.batchID)
            
            this.getBatchOrderData(data, true) 
            
            // Reinitialize your data table after data is updated
            this.reinitializeDataTable()
            
            // Close the confirmation modal or perform other actions
            document.getElementById('confirmDeleteAllModal').click();
          }
        },
        (error) => {
          console.error('Error deleting non-geocoded records:', error);
        }
      );
    } else {
      console.error('BatchID is missing. Cannot delete non-geocoded records.');
    }
    $('#confirmDeleteAllModal').modal('hide');
  }

  exportNonGeocodedToExcel() {
    // Set the loading flag to true to display a spinner
    this.loadingExport = true;
  
    const requestData = {
      PROCEDURE: 'nongeocodedreport',
      BATCH_ID: this.batchID,
      CUSTOMER_ID: this.cookieService.getCookie('customerID'),
      SESSION_ID: this.cookieService.getCookie('sessionKey'),
    };
  
    this.batchUploadService.serviceCall(JSON.stringify(requestData)).subscribe(
      (response: any) => {
        const data = JSON.parse(response._body || '{}');
  
        // Hide the spinner
        this.loadingExport = false;
  
        // Check if there are no non-geocoded records
        if (data.STATUS === 'Y' && data.NO_RECORDS === 'Y') {
          // Set the error message
          this.exportErrorMessage = 'This bulk load does not have Non-Geocoded records.';
          // Clear the success message
          this.exportSuccessMessage = '';
        } else if (data.STATUS === 'Y') {
          // Set the success message
          this.exportSuccessMessage = 'A Non-Geocoded report is generated successfully.';
          // Clear the error message
          this.exportErrorMessage = '';
        } else {
          // Set the error message
          this.exportErrorMessage = data.ERRORMESSAGE || 'An error occurred during the export process.';
          // Clear the success message
          this.exportSuccessMessage = '';
        }
      },
      (error) => {
        // Hide the spinner
        this.loadingExport = false;
  
        // Set an error message
        this.exportErrorMessage = 'An error occurred while exporting data to Excel.';
        // Clear the success message
        this.exportSuccessMessage = '';
      }
    );
  }

}